import React, { useState } from 'react';
import { Deal, TradeIn } from '@upstart/harmony/lib/legos/dealTypes';
import { Dealer } from '@upstart/harmony/lib/legos/dealerTypes';
import { PayoffRequestStatus } from '@upstart/harmony/lib/legos/lossExpressTypes';
import {
  PayoffStatusProperties,
  TradePayoffState,
} from '../../../util/tradePayoffUtils';
import Tooltip from '../../Tooltip';
import TradePayoffModal from '../TradePayoffModal';
import LossExpressService from '../../../services/LossExpressService';

interface TradePayoffModalLabelProps {
  tradeIn: TradeIn;
  dealer: Dealer;
  deal: Deal;
  tradeInIndex: number;
  payoffState: TradePayoffState;
  payoffStatusProperties: PayoffStatusProperties;
  updatePayoffAmount: (amount: number) => void;
}
export const TradePayoffModalLabel = ({
  tradeIn,
  dealer,
  deal,
  tradeInIndex,
  payoffState,
  payoffStatusProperties,
  updatePayoffAmount,
}: TradePayoffModalLabelProps) => {
  const [modalOpen, setModalOpen] = useState(false);

  const labelText = tradeIn.payoffEstimated
    ? 'Trade Payoff (Estimated)'
    : 'Trade Payoff';
  const modalSuccessText =
    tradeIn.payoffRequestStatus === PayoffRequestStatus.Success
      ? 'Close'
      : 'Confirm';
  const refreshPayoff = () => {
    // payoff lookup updates are passed asynchronously via LOSS_EXPRESS_PAYOFF_UPDATED websocket events
    LossExpressService.lookupPayoff(deal.id, {
      lenderName: tradeIn.lenderName || '',
      entityName: dealer.name || '',
      vin: tradeIn.id || '',
    });
  };

  const getSublabel = () => {
    let label;

    // if pending update (meaning an expired payoff request is awaiting response) and we have a manually entered estimated
    // payoff value, the "Payoff Lookup in Progress..." text is in the primary label and doesn't need to be added
    // here in the sublabel. If it's not estimated, we show per diem and expiration date in the primary label.
    if (
      payoffState === TradePayoffState.PENDING_UPDATE &&
      !tradeIn.payoffEstimated
    ) {
      label = 'Payoff lookup in progress...';
    } else if (payoffState === TradePayoffState.VALID) {
      label = (
        <a className="clickable" onClick={() => setModalOpen(true)}>
          View Details
        </a>
      );
    } else if (payoffState === TradePayoffState.EXPIRED) {
      label = (
        <a className="clickable" onClick={refreshPayoff}>
          Refresh Payoff Lookup
        </a>
      );
    } else if (payoffState === TradePayoffState.NOT_FOUND) {
      label = (
        <a className="clickable" onClick={() => setModalOpen(true)}>
          Try Again
        </a>
      );
    }

    return label;
  };

  return (
    <div className="modal-label">
      <div>
        {labelText}{' '}
        <Tooltip width={250} text={payoffStatusProperties.tooltip(tradeIn)}>
          <i className="glyphicon glyphicon-info-sign payoff-tooltip" />
        </Tooltip>
      </div>
      <div className="payoff-status-sublabel">
        <div>
          {payoffState === TradePayoffState.DEFAULT ? (
            <a className="clickable" onClick={() => setModalOpen(true)}>
              {payoffStatusProperties.status(tradeIn)}
            </a>
          ) : (
            payoffStatusProperties.status(tradeIn)
          )}
        </div>
        <div>{getSublabel()}</div>
      </div>
      <TradePayoffModal
        dealer={dealer}
        deal={deal}
        tradeIn={tradeIn}
        tradeInIndex={tradeInIndex}
        tradePayoffState={payoffState}
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        successButtonText={modalSuccessText}
        updatePayoffAmount={updatePayoffAmount}
      />
    </div>
  );
};
